import {
  FormInput,
  SelectInput,
  SubmitButton,
  Form,
  Grid,
  NotificationsContext,
  VerificationCodeInput,
  FormElementRef,
} from '@kirz/mui-admin';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { Email, Phone, Send } from 'mdi-material-ui';
import React, {
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

import { PngCompanyLogo } from 'components/PngCompanyLogo';
import { api } from 'services/api';
import { LoginError, LoginPayload, UserIdentity } from 'types/auth';

export function Login() {
  const formRef = useRef<FormElementRef>(null);

  const [loginStep, setLoginStep] = useState<
    'email' | 'phone' | 'identity' | 'code' | 'password'
  >('email');

  const [infoMessage, setInfoMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<ReactNode | null>(null);

  const theme = useTheme();

  const handleSubmit = async (payload: LoginPayload) => {
    const { success, errorCode, errorData } = await api.login({
      ...payload,
    });

    if (success) {
      window.location.reload();

      return;
    }

    setErrorMessage(null);
    setInfoMessage(null);

    switch (errorCode) {
      case LoginError.IDENTITY_SELECTION_REQUIRED: {
        setLoginStep('identity');
        setInfoMessage('Uw account is gekoppeld aan meerdere bedrijven');
        break;
      }
      case LoginError.PHONE_VALIDATION_REQUIRED: {
        setLoginStep('code');
        break;
      }

      case LoginError.PASSWORD_VALIDATION_REQUIRED: {
        setLoginStep('password');
        setInfoMessage('Voer uw wachtwoord in');
        break;
      }
      case LoginError.IDENTITY_NOT_FOUND: {
        setErrorMessage('User not found');
        setLoginStep('email');
        break;
      }
      case LoginError.WRONG_PASSWORD: {
        setErrorMessage('Wrong password');
        break;
      }
      case LoginError.WRONG_VALIDATION_CODE: {
        setErrorMessage('Wrong verification code');
        break;
      }
      case LoginError.PHONE_VALIDATION_FAILED: {
        setErrorMessage('Verkeerde verificatiecode');
        break;
      }
      default: {
        throw new Error(`Unknown error: ${errorCode}`);
      }
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}
    >
      <Paper elevation={16} sx={{ flex: 1, p: 4, width: '100%' }}>
        <Stack
          alignItems="center"
          spacing={0.75}
          sx={{ position: 'relative', pt: 2 }}
        >
          <PngCompanyLogo
            htmlColor={theme.palette.brand.main}
            sx={{
              width: 60,
              position: 'absolute',
              // left: -10,
              top: -10,
            }}
          />
          <Box sx={{ height: '27px' }} />
          <Typography variant="h4">Вход</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Система управления контентом
          </Typography>
          <Form
            ref={formRef}
            sx={{ pt: 2, alignSelf: 'stretch' }}
            onSubmit={handleSubmit}
            spacing={2}
            shouldUnregister={false}
            dirtySubmit={false}
          >
            {infoMessage && (
              <Grid xs={12}>
                <Alert severity="warning">{infoMessage}</Alert>
              </Grid>
            )}
            {errorMessage && (
              <Grid xs={12}>
                <Alert severity="error">{errorMessage}</Alert>
              </Grid>
            )}

            <FormInput
              label="E-mail"
              clearable
              required
              name="email"
              type="email"
              autoFocus
              placeholder="your-email@gmail.com"
            />
            <FormInput
              label="Пароль"
              name="password"
              type="password"
              autoFocus
              placeholder="********"
            />
            <Grid xs={12}>
              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={() => {
                  formRef.current?.submit();
                }}
              >
                Войти в систему
              </Button>
            </Grid>
          </Form>
        </Stack>
      </Paper>
    </Container>
  );
}
